<template>
  <div>
    <!-- 面包屑导航区域 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{path: '/home'}">首页</el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
      <el-breadcrumb-item>产品查询</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card>
      <div class="twoform">
        <el-form :model="inquireForm" :inline="true" ref="addFormRef" label-width="80px">
          <el-form-item label="产品类型" prop="TypeName">
            <el-select v-model="productTypeList.TypeName" size="mini" placeholder="请选择产品类型" clearable>
              <el-option v-for="item in productTypeList" :key="item.ID" :label="item.TypeName" :value="item.ID">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="产品编号" prop="ProductNO">
            <el-input v-model="inquireForm.ProductNO" size="mini" clearable placeholder="请输入产品编号"></el-input>
          </el-form-item>
          <el-form-item label="产品名称" prop="ProductName">
            <el-input v-model="inquireForm.ProductName" size="mini" clearable placeholder="请输入产品名称"></el-input>
          </el-form-item>
          <el-form-item label="仓位编号" prop="StorageLocationNO">
            <el-input v-model="inquireForm.StorageLocationNO" size="mini" clearable placeholder="请输入仓位编号"></el-input>
          </el-form-item>
          <el-form-item label-width="0">
            <el-button type="primary" size="mini" icon="el-icon-search" @click="inquireProduct()">搜索</el-button>
          </el-form-item>
        </el-form>
      </div>
      <!-- 产品信息表格 -->
      <el-table :data="inquireList">
        <el-table-column type="index" label="序号" align="center"></el-table-column>
        <el-table-column label="产品类型" prop="TypeName" align="center"></el-table-column>
        <el-table-column label="产品编号" prop="ProductNO" align="center"></el-table-column>
        <el-table-column label="产品名称" prop="ProductName" align="center"></el-table-column>
        <el-table-column label="产品编码" prop="ProductCode" align="center"></el-table-column>
        <el-table-column label="规格型号" prop="Spec" align="center"></el-table-column>
        <el-table-column label="单位" prop="Unit" align="center"></el-table-column>
        <el-table-column label="仓位编号" prop="StorageLocationNO" align="center"></el-table-column>
        <el-table-column label="库存上限数量" prop="Stock_Up" align="center"></el-table-column>
        <el-table-column label="库存下限数量" prop="Stock_Down" align="center"></el-table-column>
      </el-table>
    </el-card>

    <!-- 查询产品的会话框 -->
    <el-dialog title="设置物料" :visible.sync="setingDialogVisible" width="80%" @close="setingDialogClose">
      <el-table :data="ProducIDMaterialList" border stripe>
        <el-table-column type="index"></el-table-column>
        <el-table-column label="产品类型" prop="TypeName"></el-table-column>
        <el-table-column label="创建人" prop="CreateUser" width="150px"></el-table-column>
        <el-table-column label="是否使用" prop="Is_Use" width="120px"></el-table-column>
        <el-table-column label="备注" prop="Remark" width="250px"></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="primary" icon="el-icon-edit" size="mini" @click="">编辑</el-button>
            <el-button type="danger" icon="el-icon-delete" size="mini" @click="">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button size="sedium" @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" size="sedium" @click="editProduct">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
    data () {
        return {
            getTypeList: {
                page: '1',
                limit: '10',
                privateKey: '12a5081e-e354-bada-3952-7a0df30d8849',
                appIdentification: 'wms'
            },
            // 产品管理信息表
            productManageList: [],
            //查询信息的表单数据
            inquireForm: {
                TypeName: '',
                ProductNO: '',
                ProductName: '',
                StorageLocationNO: ''
            },
            // 产品类型信息表
            productTypeList: [],
            // 点击查询按钮查询到的信息
            inquireList: {}
        }
    },
    created () {
        this.getStorageList()
        this.getType()
        this.inquireProduct()
    },
    methods: {
        //调用接口获取仓库储位信息
        async getStorageList () {
            //const { data: res } = this.$http.get(`/queryStorageLocation/${params}`)
            //const { data: res } = this.$http.get(`/queryStorageLocation/${this.page}/${this.limit}/${this.privateKey}/${this.appIdentification}`)
            const { data: res } = await this.$http.get('/WMS/queryProducRelate', { params: this.getTypeList })
            console.log(res.data)
            this.productManageList = res.data
        },
        // 调用接口获取产品类型
        async getType () {
            const { data: res } = await this.$http.get('/WMS/queryProductType', { params: this.getTypeList })
            console.log(res.data)
            this.productTypeList = res.data
        },
        // 调用接口查询产品
        async inquireProduct () {
            let params = new URLSearchParams()
            params.append("privateKey", this.getTypeList.privateKey)
            params.append("appIdentification", this.getTypeList.appIdentification)
            params.append("ProductType_ID", this.productTypeList.TypeName)
            params.append("ProductNO", this.inquireForm.ProductNO)
            params.append("ProductName", this.inquireForm.ProductName)
            params.append("StorageLocationNO", this.inquireForm.StorageLocationNO)
            console.log('65561315315')
            console.log('b' + params)
            const { data: res } = await this.$http.post('/WMS/queryProducRelateSelect', params)
            console.log(res.data)
            this.inquireList = res.data
        },
    }
}
</script>

<style lang="less" scoped>
.form {
  display: flex;
}
.btn {
  margin-left: 1%;
}
.button {
  width: 130%;
}
.twoform {
  display: flex;
}
</style>

